import { useTranslation } from 'react-i18next';
import type { Project } from '@claude-code-api/shared';
import { FolderGit2 } from 'lucide-react';
import { CreateProjectButton } from '@/components/CreateProjectButton';

interface EmptyProjectsProps {
  onProjectCreated: (project: Project) => void;
}

export function EmptyProjects({ onProjectCreated }: EmptyProjectsProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="border-2 border-dashed rounded-lg p-12 text-center">
      <div className="mx-auto w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
        <FolderGit2 className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold">{t('emptyProjectsTitle')}</h3>
      <p className="text-sm text-muted-foreground mb-4">
        {t('emptyProjectsDescription')}
      </p>
      <CreateProjectButton onProjectCreated={onProjectCreated} />
    </div>
  );
}
